import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';

export const assignProductAccountEntitlementsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    {resourceIds?: string[], resourceQuery: string}
>('assignProductAccountEntitlementsState', undefined);

export const assignProductAccountEntitlementsStateActions =
    assignProductAccountEntitlementsStateSlice.actions;

export const assignProductAccountEntitlementsStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    {resourceIds?: string[], resourceQuery: string}
> = state => state.accountPage.assignProductEntitlements.state;
